import { render, staticRenderFns } from "./Block3Employee.vue?vue&type=template&id=a6f2cb0a"
import script from "./Block3Employee.vue?vue&type=script&lang=ts"
export * from "./Block3Employee.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports